<template>
  <div>
    <PublicHeader v-bind="$props" />
    <div class="p-col-12 min-vh-50 mt-6rem">
      <div class="leaderboard schedules">
        <div class="has-text-left p-lg-4">
          <h1 class="title is-3">{{ $t("scores") }}</h1>
          <h5 class="is-5">{{ seasonName }}</h5>

          <div class="p-d-flex mt-5">
            <b-select :placeholder="$t('select-division')" expanded v-model="selectedDivision" class="mr-3">
              <option v-for="d in divisions" :value="d.id" :key="d.id">
                {{ d.name }}
              </option>
            </b-select>

            <b-select :placeholder="$t('select-team')" expanded v-model="selectedTeam" class="mr-3">
              <option
                v-for="t in teams"
                v-show="!selectedDivision || t.division_id === selectedDivision"
                :value="t.id"
                :key="t.id"
              >
                {{ t.name }}
              </option>
            </b-select>

            <Button class="p-button-text" @click="clearFilter">{{ $t("Butoon.clear-filters") }}</Button>
          </div>
        </div>

        <ProgressSpinner v-if="loading" />
        <div v-else>
          <div class="p-col-12">
            <DataTable
              :scrollable="true"
              class="p-datatable-sm p-datatable-striped whiteBg mt-3"
              dataKey="id"
              :value="filteredGames"
            >
              <Column field="start" :header="$t('publicScoresHeaders.start')"></Column>
              <Column field="startTime" :header="$t('publicScoresHeaders.startTime')"></Column>
              <Column field="visitor_name" :header="$t('publicScoresHeaders.visitor_name')"></Column>
              <Column field="home_name" :header="$t('publicScoresHeaders.home_name')"></Column>
              <Column field="visitor_score" :header="$t('publicScoresHeaders.visitor_score')"></Column>
              <Column field="home_score" :header="$t('publicScoresHeaders.home_score')"></Column>
              <Column field="overtime" :header="$t('publicScoresHeaders.overtime')"></Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
    <PublicFooter v-bind="$props" />
  </div>
</template>

<script>
import api from "@/api";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import PublicHeader from "@/components/PublicHeader.vue";
import PublicFooter from "@/components/PublicFooter.vue";
export default {
  metaInfo() {
    return {
      ...this.metaContent,
      title: `${this.leagueName} Scores | Diamond Scheduler`,
    };
  },
  props: [
    "seasonId",
    "logoUrl",
    "showTeamsPage",
    "showStandingsPage",
    "showSchedulesPage",
    "showScoresPage",
    "showRostersPage",
    "domain",
    "leagueName",
    "metaContent",
  ],
  components: { PublicFooter, PublicHeader, DataTable, Column },
  data() {
    return {
      selectedDivision: null,
      selectedTeam: null,
      seasonName: "",
      divisions: [],
      teams: [],
      games: [],
      loading: true,
    };
  },
  methods: {
    fetchData(seasonId) {
      api.getPublicDivisions(seasonId).then(response => {
        if (!response.data.length) return;

        this.seasonName = response.data[0].season.name;
        this.divisions = response.data.filter(d => !d.is_across);
        this.teams = [
          ...new Map(
            response.data
              .map(d => d.teams)
              .flat()
              .map(t => [t.id, t]),
          ).values(),
        ];
        this.games = response.data
          .map(d =>
            d.games
              .filter(g => !g.is_practice)
              .map(g => ({
                ...g,
                home_score: g.home_score || 0,
                visitor_score: g.visitor_score || 0,
                startTime: this.$moment(g.start).format("h:mm A"),
                start: this.$moment(g.start).format("MM-DD-YY"),
                startTime: this.$moment(g.start).format("HH:mm A"),
                overtime: g.overtime ? this.$t("Buttton.yes") : this.$t("Buttton.no"),
              })),
          )
          .flat()
          .sort((a, b) => new Date(a.start) - new Date(b.start));
        this.loading = false;
      });
    },
    clearFilter() {
      this.selectedTeam = null;
      this.selectedDivision = null;
    },
  },
  computed: {
    filteredGames() {
      if (this.selectedDivision && !this.selectedTeam) {
        return this.games.filter(g => g.division_id === this.selectedDivision);
      }

      if (this.selectedTeam) {
        return this.games.filter(g => g.home_id === this.selectedTeam || g.visitor_id === this.selectedTeam);
      } else {
        return this.games;
      }
    },
  },
  mounted() {
    this.fetchData(this.seasonId);
  },
};
</script>
